export const VIEW_MODES = {
    AUTH: 'auth',
    HOME: 'home',
    REPORT: 'report',
    POTITTO: 'potitto',
    MANSION_ASSESSMENT: 'mansion_assessment'
}